import moment from "moment";
import "moment/locale/es";

// Colores de origen: los mismos del dashboard (naranja de marca para la app, azul para la web),
// validados como par para daltonismo. El texto nunca va en estos colores: solo el chip.
export const SOURCE_COLORS = {
    app: "#EA580C",
    web: "#2563EB",
    api: "#6B7280",
    webhook: "#6B7280",
    system: "#6B7280",
    other: "#6B7280",
};

export const SOURCE_LABELS = {
    app: "App",
    web: "Web",
    api: "API",
    webhook: "Webhook",
    system: "Sistema",
    other: "Otro",
};

export const ERROR_KIND_LABELS = {
    server: "Servidor",
    client: "Cliente",
    rejected: "Rechazo",
    slow: "Lento",
};

export const CHANNEL_LABELS = {
    meli: "Mercado Libre",
    bsale: "Bsale",
    relbase: "Relbase",
    shopify: "Shopify",
    manual: "Manual",
    importacion: "Importación",
    api: "API",
    noform: "Noform",
};

const GUIDE_STATES = {
    "guide.opened": "abrió la guía",
    "guide.completed": "terminó la guía",
    "guide.abandoned": "dejó a medias la guía",
    "guide.offer_accepted": "aceptó el recorrido de guías",
    "guide.offer_declined": "dijo \"Ahora no\" a las guías",
};

// Con el locale por instancia: cambiar el global de moment afectaria otras pantallas.
export const timeAgo = (value) => (value ? moment(value).locale("es").fromNow() : "-");
export const clock = (value) => (value ? moment(value).format("HH:mm:ss") : "-");
export const dateTime = (value) => (value ? moment(value).format("DD/MM HH:mm") : "-");

// Severidad de un item del feed, para el punto de color: "error", "warning" u "ok".
export function feedTone(item) {
    if (item.type === "error") return item.kind === "rejected" || item.kind === "slow" ? "warning" : "error";
    const p = item.props || {};
    if (item.name === "trip.optimized" && p.ok === false) return "error";
    if (item.name === "delivery.cancelled" || item.name === "order.deleted" || item.name === "guide.abandoned") return "warning";
    if (item.name === "bug_report.created") return "warning";
    return "ok";
}

// Que paso, en una linea, como lo leeria alguien de operaciones.
export function describe(item) {
    const p = item.props || {};
    if (item.type === "error") {
        const where = item.endpoint || item.screen || "";
        const kind = ERROR_KIND_LABELS[item.kind] || item.kind;
        return `${kind}${item.status ? ` ${item.status}` : ""}: ${item.message || item.error_class || ""}${where ? ` · ${where}` : ""}`;
    }

    switch (item.name) {
        case "order.created":
            return `Pedido ${p.code || ""} creado vía ${CHANNEL_LABELS[p.channel] || p.channel || "?"}`;
        case "order.deleted":
            return `Pedido ${p.code || ""} eliminado`;
        case "trip.created":
            return `Viaje ${p.code || ""} creado${p.state === "planned" ? " (borrador)" : ""}`;
        case "trip.optimized":
            if (p.ok === false) return `Falló la optimización del viaje ${p.code || ""}: ${p.error || "sin detalle"}`;
            return `Optimizó el viaje ${p.code || ""} · ${p.stops ?? "?"} paradas en ${((p.ms || 0) / 1000).toFixed(1)} s${p.trigger === "inicio_viaje" ? " (al iniciar)" : ""}`;
        case "trip.reordered":
            return `Reordenó a mano el viaje ${p.code || ""}`;
        case "trip.started":
            return `Inició el viaje ${p.code || ""} · ${p.stops ?? "?"} paradas`;
        case "trip.finished":
            return `Terminó el viaje ${p.code || ""} · ${p.finished ?? 0}/${p.stops ?? 0} entregadas${p.cancelled ? `, ${p.cancelled} no entregadas` : ""}`;
        case "delivery.finished": {
            const late = typeof p.minutes_vs_plan === "number" && p.minutes_vs_plan > 15 ? ` · ${p.minutes_vs_plan} min tarde` : "";
            return `Cerró la entrega ${p.code || ""}${p.signed ? " con firma" : " sin firma"}${late}`;
        }
        case "delivery.cancelled":
            return `Entrega ${p.code || ""} no entregada${p.comment ? `: ${p.comment}` : ""}`;
        case "user.login":
            return `Ingresó${p.via === "otp" ? " a la app" : " a la web"}`;
        case "bug_report.created":
            return `Reportó un problema${p.screen ? ` en ${p.screen}` : ""}: ${p.message || ""}`;
        default:
            if (GUIDE_STATES[item.name]) {
                const step = p.step != null && p.total ? ` (paso ${p.step} de ${p.total})` : "";
                return `${GUIDE_STATES[item.name].charAt(0).toUpperCase()}${GUIDE_STATES[item.name].slice(1)}${p.guide ? ` ${p.guide}` : ""}${step}`;
            }
            return item.name;
    }
}

export const pct = (value) => (value === null || value === undefined ? "-" : `${value}%`);
